import { RefetchDomFn } from '@shared/contexts/ExtensionMessagingContext';
import { isNil } from 'lodash';

type RefetchDomParams = {
  domTimeout: number;
  shipmentUrls?: string[];
  refetchDom: RefetchDomFn;
};

export const getRefetchDomPromise = (
  params: RefetchDomParams
): Promise<string[] | null> => {
  const { domTimeout, shipmentUrls, refetchDom } = params;

  if (!shipmentUrls || shipmentUrls.length === 0) {
    return refetchDom(domTimeout).then((res) => {
      return toStringArrayOrNull([res?.domContent]);
    });
  }

  return fetchSerial({ domTimeout, shipmentUrls, refetchDom });
};

async function fetchSerial(
  params: NonNullable<RefetchDomParams> & { shipmentUrls: string[] }
) {
  const { domTimeout, shipmentUrls, refetchDom } = params;

  const doms = [];
  for (const url of shipmentUrls) {
    const result = await refetchDom(domTimeout, { url });
    doms.push(result?.domContent);
  }
  return toStringArrayOrNull(doms);
}

export const toStringArrayOrNull = (
  arr: (string | null | undefined)[]
): string[] | null => {
  const nonNull = arr.filter((a) => !isNil(a));
  if (nonNull.length === 0) return null;
  return nonNull;
};
